
<tui-root style="width:100%;height:100%">
    <router-outlet></router-outlet>
    <ng-container ngProjectAs="tuiOverContent">
        <div #componentContainer></div>

      </ng-container>

      <ng-container ngProjectAs="tuiOverDialogs">

      <div class="custom-overlay-container"></div>
      <ngx-sonner-toaster richColors  />
    </ng-container>
</tui-root>
